<div class="modal-content">
    <div class="modal-toggle-wrapper social-profile text-start dark-sign-up">
      <h4 class="modal-header justify-content-center border-0 text-dark">Cadastrando novo Cliente</h4>
      <div class="modal-body">
        <form class="row g-3 needs-validation" [formGroup]="realDeskForm" >
          <div class="col-md-12">
            <label class="form-label" for="validationCustom01">Nome (*)</label>
            <input class="form-control" id="validationCustom01" type="text" formControlName="nome"  >
            <div class="valid-feedback">Looks good!</div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label class="form-label" for="exampleFormControlInput1">Email</label>
              <input class="form-control" id="exampleFormControlInput1" type="email"   formControlName="email">
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label class="form-label" for="exampleFormControlInput1">Telefone</label>
              <input class="form-control" id="exampleFormControlInput1" type="text"  formControlName="telefone">
            </div>
          </div>
          <div class="col-md-12">
            <small class="tooltip-info">Pelo menos um dos campos "Telefone" ou "Email" deve ser preenchido.</small>
          </div>
          <div class="col-md-12" class="col-md-12 d-flex justify-content-between">
            <button  [disabled]="isLoading" class="btn btn-secondary" type="submit" (click)="closeModal()">
                <i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i> Cancelar</button>
            <button [disabled]="realDeskForm.invalid || isLoading" class="btn btn-primary" type="submit" (click)="submit()">
              <i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i> Cadastrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  